import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAffordable = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_11320",
		"data-name": "Group 11320",
		transform: "translate(-360 -71)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11603",
				"data-name": "Path 11603",
				d: "M0,0H24V24H0Z",
				transform: "translate(360 71)",
				fill: "none"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11604",
				"data-name": "Path 11604",
				d: "M6,21H4a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H6a1,1,0,0,1,1,1v6A1,1,0,0,1,6,21Z",
				transform: "translate(360 71)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11605",
				"data-name": "Path 11605",
				d: "M13,17h2.333a2,2,0,0,0,1.2-.4l2.416-1.812a1.515,1.515,0,0,1,1.98.141h0a1.514,1.514,0,0,1,0,2.142l-2.073,2.073a4,4,0,0,1-2.044,1.094l-2.93.586a4,4,0,0,1-1.755-.042l-2.65-.662A3.957,3.957,0,0,0,8.508,20H7",
				transform: "translate(360 71)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11606",
				"data-name": "Path 11606",
				d: "M13,17h1.485A1.515,1.515,0,0,0,16,15.485v-.3a1.514,1.514,0,0,0-1.147-1.469l-2.292-.573A4.705,4.705,0,0,0,11.422,13h0a4.69,4.69,0,0,0-2.605.789L7,15",
				transform: "translate(360 71)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11607",
				"data-name": "Path 11607",
				d: "M17.169,5.155a2.838,2.838,0,1,1-4.014,0,2.838,2.838,0,0,1,4.014,0",
				transform: "translate(360 71)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11608",
				"data-name": "Path 11608",
				d: "M14.631,4.375a2.834,2.834,0,1,0-2.263,3.249",
				transform: "translate(360 71)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	})
});
export default SvgAffordable;
